import React, { useEffect, useRef, useMemo, useState } from 'react';
import SpeciesListEntry from './SpeciesListEntry';
import AnimalList from './AnimalList';
import { getLatestPing } from '../utilities/time';

export default function SpeciesList(props: any) {
  const ref = useRef<HTMLUListElement>(null);
  const [selected, setSelected] = useState<any | null>(null);
  const { onClickOutside } = props;
  const groupKey = props.group.key || props.group.name;
  const showSpeciesList = props.isMobile ? !selected : true;
  const showAnimalList = props.isMobile ? !!selected : !!selected;
  const headerLabel = props.group.accessibilityLabel ?? props.group.name;

  const trackedEntries = useMemo(() => props.group.entries
    .filter((entry: any) => entry.individuals.length !== 0),
    [props.group.entries]
  );

  const listItems = useMemo(() => trackedEntries
    .map((entry: any, index: number) => ({
      entry,
      key: `${entry.speciesKey || entry.name}:${entry.group || groupKey}:${entry.individuals?.[0]?.tagId || 'none'}:${index}`,
      lastPing: getLatestPing(entry.individuals),
    }))
    .sort((a: { lastPing: number }, b: { lastPing: number }) => a.lastPing - b.lastPing)
    .map(({ entry, key, lastPing }: { entry: any; key: string; lastPing: number }) => (
      <SpeciesListEntry
        key={key}
        item={entry}
        lastPing={lastPing}
        onSelected={(item: any) => setSelected(item)} />
    )),
    [groupKey, trackedEntries]
  )
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      onClickOutside && onClickOutside(event);
    };
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [onClickOutside]);

  return (
    <div className={`popup-container ${props.isMobile ? 'popup-container--mobile' : 'popup-container--desktop'}`}>
      <div className={props.isMobile ? undefined : 'species-popup-stack'}>
        {showSpeciesList && (
          <div className="species-popup">
            <p className='species-popup-header'>{headerLabel} - {trackedEntries.length} species</p>
            {trackedEntries.length !== 0
              ? (
                <ul className='species-list' ref={ref}>
                  {listItems}
                </ul>
              )
              : <div style={{ margin: 'auto auto', width: '100%', textAlign: 'center' }}>COMING SOON</div>
            }
          </div>
        )}
        {showAnimalList && selected && (
          <AnimalList inlineDesktop={!props.isMobile} group={selected} name={selected.name} onSelected={(animal: any) => {
            props.onSelected(animal);
            if (props.isMobile) {
              setSelected(null);
              props.onClose?.();
            }
          }} onClickOutside={onClickOutside} />
        )}
      </div>
    </div>
  )
}